import { Dispatch } from "react";
import { MixPuzzleInstrument } from "shared/games/mixpuzzles/types";
import Button from "ui/atoms/Button/Button";
import SubControlBar from "../atoms/SubControlBar";
import Action from "../state/actions";
import { State } from "../state/reducer";
import { isMuted, isSoloed } from "../state/selectors";

interface Props {
  dispatch: Dispatch<Action>;
  state: State;
  instrument: MixPuzzleInstrument;
}

export default function MobileActionControlBar({
  instrument,
  state,
  dispatch,
}: Props) {
  return (
    <SubControlBar>
      <div className="mr-2 flex">
        <div className="mr-2">
          <Button
            theme="blue"
            active={isMuted(state, instrument.instrument)}
            onClick={() =>
              dispatch({
                type: "updateMuted",
                payload: instrument.instrument,
              })
            }
          >
            Mute
          </Button>
        </div>

        <Button
          theme="yellow"
          active={isSoloed(state, instrument.instrument)}
          onClick={() =>
            dispatch({
              type: "updateSoloed",
              payload: instrument.instrument,
            })
          }
        >
          Solo
        </Button>
      </div>

      <Button
        theme="red"
        outline
        onClick={() => dispatch({ type: "startover" })}
      >
        Start over
      </Button>
    </SubControlBar>
  );
}
